<script setup lang="ts">
    const { name, values, options } = defineProps<{
        name: string
        values: Array<string>
        options: Array<{
            variant: string
            swatch?: {
                url?: string
            }
        }>
    }>()

    const activeVariant = defineModel()

    const maxSwatches = 8

    const optionsWithSwatches = computed(() =>
        options.filter((option) => !!option.swatch?.url),
    )

    const swatchesToDisplay = computed(() => {
        if (optionsWithSwatches.value.length <= maxSwatches) {
            return optionsWithSwatches.value
        }

        return optionsWithSwatches.value.slice(0, maxSwatches - 1)
    })
</script>

<template>
    <div
        class="flex w-full flex-col justify-between gap-2 align-top text-xs uppercase leading-tight lg:gap-0 lg:text-base xl:flex-row"
    >
        <p class="leading-tight lg:mb-2">
            {{ values.length }} {{ name
            }}{{ values.length == 1 ? '' : 's' }} available
        </p>

        <ul class="flex gap-[6px]">
            <li
                v-for="option in swatchesToDisplay"
                class="aspect-square h-7 w-7 md:h-8 md:w-8 lg:h-9 lg:w-9"
                @mouseleave="activeVariant = undefined"
                @mouseover="activeVariant = option.variant"
            >
                <img
                    :src="option.swatch.url"
                    :alt="`${option.variant} ${name}`"
                    class="h-full w-full object-cover"
                />
            </li>

            <li
                v-if="optionsWithSwatches.length > maxSwatches"
                class="flex aspect-square h-7 items-center justify-center bg-dark text-xs text-white md:h-8 md:text-sm lg:h-9"
            >
                +{{ optionsWithSwatches.length - maxSwatches + 1 }}
            </li>
        </ul>
    </div>
</template>
>
